import { ChangeEvent, FC, useState } from "react";
import { Button, Drawer, Input, LegacyForm, useMessagedAsyncFn } from "@payping/web-components";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Close } from "@payping/icons";
import { ValidEmail } from "@payping/utils/validation";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { accountApis } from "@payping/api";
import { DashboardRoutes } from "@/router/constant";
import { isPersonalDisable } from "@/mobile/Settings/Personal/Edit/isPersonalDisable";
import { useHandleNavigationURL, useSaveToRedux } from "@/mobile/Settings/Personal/utils";
import { settingsPersonalAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsPersonalAtom, (val) => val.mobileFormEdit);

const MobileEditPersonalEmail: FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [form] = LegacyForm.useForm();
  const { t } = useAppTranslation();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const emailApi = useAppSelector((state) => state.user.personalInfo?.email);

  const [email, setEmail] = useState<string | undefined>();

  const [{ loading: sendingEmailVerifyLoading }] = useMessagedAsyncFn(
    async () => {
      await form.validateFields(["email"]);
      await accountApis.sendVerificationEmailGet(/* form.getFieldValue("email") */);
    },
    [form],
    undefined,
    { success: t("profile.personal.successSendEmail") },
  );

  // Custom Hooks
  const { handleNavigationURL } = useHandleNavigationURL();
  const { saveToRedux } = useSaveToRedux();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        title={`${t("edit")} / ${t("email")}`}
        size={"100%"}
        placement={"bottom"}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <LegacyForm
          onFinish={() =>
            saveToRedux({
              nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditPersonal.documents.url,
              fieldName: "email",
              fieldValue: email,
              setIsDrawerOpen,
            })
          }
          form={form}
          initialValues={{ email: mobileFormEditState.email ?? emailApi }}
        >
          <LegacyForm.Item
            name="email"
            rules={[
              () => ({
                validator(_, value): Promise<void> {
                  if (ValidEmail(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("profile.validEmail")));
                },
              }),
              { message: t("error.requiredForTaxCode", { name: t("email") }), required: true },
            ]}
            required
            normalize={(value) => value.trim()}
          >
            <Input
              value={email}
              placeholder={t("mobileEditPersonal.enterField", { fieldName: t("common.email") })}
              onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
              disabled={isPersonalDisable()}
            />
          </LegacyForm.Item>
        </LegacyForm>
      </Drawer>
      <EditActionButtons loading={sendingEmailVerifyLoading} onAccept={form.submit} />
    </>
  );
};

export default MobileEditPersonalEmail;
